import React, { useState, useContext } from 'react';
import { TreeView, TreeItem } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { IconButton, Chip, Button, Toolbar, Box, Typography, Tooltip } from '@mui/material';

import { Search, Add, Delete, Edit } from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';

import MyLayout from '../../layout/layout';
import { CategoriesContext, CategoriesProvider } from '../context/CategoriesContext';
// import { routeName } from '../routes/paths';
import CategoryModal from '../components/CategoryModal';
import ConfirmDialog from '../../../components/ConfirmDialog';

export default function Categories() {
  return (
    <MyLayout>
      <CategoriesProvider>
        <Toolbar>
          <Typography variant='h6' noWrap component='div' sx={{ flexGrow: 1 }}>
            Categories
          </Typography>
        </Toolbar>

        <CategoriesTree />
      </CategoriesProvider>
    </MyLayout>
  );
}

const CategoriesTree = () => {
  const {
    categoriesTree,
    selected,
    handleSelect,
    handleAddCategory,
    handleDeleteSubmit,
    handleEditCategory,
    handleDeleteSelected,
  } = useContext(CategoriesContext);
  const [openDialog, setOpenDialog] = useState(false);

  const renderTree = (nodes) => (
    <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.name}>
      {Array.isArray(nodes.children) ? nodes.children.map((node) => renderTree(node)) : null}
    </TreeItem>
  );

  const showSelectCateogy = (
    <>
      <div style={{ mr: 5 }}>Selected Category : </div>
      {selected ? (
        <>
          <Chip sx={{ ml: 3 }} label={selected?.name} onDelete={handleDeleteSelected} />
          <Box component='div' sx={{ ml: 5 }}>
            <Tooltip title='Add new category under selected parent' placement='top'>
              <IconButton color='primary' onClick={handleAddCategory}>
                <Add />
              </IconButton>
            </Tooltip>
            <Tooltip title='Edit selected category' placement='top'>
              <IconButton color='warning' onClick={handleEditCategory}>
                <Edit />
              </IconButton>
            </Tooltip>
            {selected.children?.length > 0 ? null : (
              <Tooltip title='Delete selected category' placement='top'>
                <IconButton
                  color='error'
                  onClick={() => {
                    setOpenDialog(true);
                  }}>
                  <Delete />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </>
      ) : null}
    </>
  );

  const showAddNewCat = (
    <Button startIcon={<Add />} onClick={handleAddCategory}>
      Add new Root Category
    </Button>
  );

  return (
    <>
      <Toolbar sx={{ width: '100%', backgroundColor: '#e8e8e8', my: 2 }}>
        {selected ? showSelectCateogy : showAddNewCat}
      </Toolbar>
      <TreeView
        selected={selected}
        onNodeSelect={handleSelect}
        aria-label='rich object'
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpanded={['root']}
        defaultExpandIcon={<ChevronRightIcon />}
        sx={{ height: '100%', flexGrow: 1, maxWidth: 800, overflowY: 'auto' }}>
        {categoriesTree.map((parent) => renderTree(parent))}
      </TreeView>
      <CategoryModal />
      <ConfirmDialog
        title='Delete Category?'
        content={`Are you sure to delete category: ${selected?.name}?`}
        submitText='Delete'
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onSubmit={() => {
          handleDeleteSubmit();
          setOpenDialog(false);
        }}
      />
    </>
  );
};
